import React, { useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Combination, OrderCombination } from '../../interfaces';

interface EditFlexibleCombinationPopupProps {
    onClose: () => void;
    combination: Combination | undefined;
    existingOrderCombination: OrderCombination;
    onSave: (orderCombination: OrderCombination) => void;
}

const EditFlexibleCombinationPopup: React.FC<EditFlexibleCombinationPopupProps> = ({ onClose, combination, onSave, existingOrderCombination }) => {
    const [newCombination, setNewCombination] = useState<OrderCombination | null>(null);

    useEffect(() => {
        if (existingOrderCombination) {
            setNewCombination(existingOrderCombination);
        }
      
    }, [ existingOrderCombination]);

    const handleSave = () => {
        if (newCombination) {
            console.log("saving")
            console.log(newCombination)
            onSave(newCombination);
        }

    }

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);

        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);

    const handleCheckboxChange = (productId: string, productName: string, checked: boolean) => {
        if (!newCombination || !combination) return;
        if (combination.subproductCategories) {

            const updatedIds = checked
                ? [...newCombination.selectedsubproductsIds, productId]
                : newCombination.selectedsubproductsIds.filter(id => id !== productId);

            const updatedNames = updatedIds.map(id => {
                const productName = getCombProductNameById(id);
                return productName || '';
            });

            console.log("updatedNames")
            console.log(updatedNames)
            setNewCombination({
                ...newCombination,
                selectedsubproductsNames: updatedNames,
                selectedsubproductsIds: updatedIds,
            });
        }


    };

    const getCombProductNameById = (id: string) => {
        for (const category of combination?.subproductCategories || []) {
            const product = category.products.find(p => p.id === id);
            if (product) {
                return product.productName; 
            }
        }
        return null; 
    };

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1000,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxHeight: windowSize.height * 0.7,
            height: windowSize.height * 0.7,

        },
    });



    return (
        <div style={styles.popup} className='ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-between'>
                <h5>Lunch Combo</h5>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div className='pb-3' style={{ paddingLeft: 20 }}>
                <div className="mt-3 thin-scrollbar" style={{ overflowY: 'scroll', maxHeight: windowSize.height * 0.7 - 130 }}>
                    <p>Flexible combination short description goes here.</p>
                    {
                        combination?.subproductCategories?.map((category, categoryIndex) => (
                            <div key={categoryIndex} style={{ paddingRight: 20 }}>
                                <label className='mb-1'>{category.name}</label>
                                <div className='border-box p-2'>
                                    {
                                        category.products.map((prod) => (
                                            <div
                                                key={prod.id}
                                                className='mb-2'
                                                style={{ display: 'grid', gridTemplateColumns: 'auto 1fr 120px', gap: 7 }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={newCombination?.selectedsubproductsIds.includes(prod.id)}
                                                    onChange={(e) =>
                                                        handleCheckboxChange(
                                                            prod.id || '',
                                                            prod.productName || '',
                                                            e.target.checked
                                                        )
                                                    }
                                                />
                                                <label>{prod.productName}</label>
                                                <div className='d-flex justify-content-end'>
                                                    <label>{prod.totalPrice}</label>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className='p-2 d-flex justify-content-end' style={{ backgroundColor: '#F3F4F6', position: 'absolute', width: '100%', bottom: 0 }}>
                <button className='blue-filled-btn' onClick={handleSave}>Save</button>
            </div>
        </div>
    );
};

export default EditFlexibleCombinationPopup;

